import { useEffect, useRef, useState } from 'react';

/**
 * Renders children only when near the viewport.
 * Keeps layout space via minHeight to avoid design jump.
 */
function LazyWhenVisible({
  children,
  rootMargin = '200px 0px',
  minHeight = 0,
  className = '',
  once = true,
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || visible) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          if (once) observer.disconnect();
        }
      },
      { rootMargin, threshold: 0.01 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [rootMargin, once, visible]);

  return (
    <div
      ref={ref}
      className={className}
      style={visible || !minHeight ? undefined : { minHeight }}
    >
      {visible ? children : null}
    </div>
  );
}

export default LazyWhenVisible;
